import { Checkbox as AriaCheckbox, VisuallyHidden } from "@ariakit/react";
import { type ComponentPropsWithRef, type ReactNode, useState } from "react";
import {
	type LabelVariants,
	childrenStyles,
	input,
	label,
} from "./Checkbox.css";
import { ToggleSwitch } from "./Toggle";
import type { TrackVariants } from "./Toggle.css";

interface CheckboxProps extends ComponentPropsWithRef<"input"> {
	children?: ReactNode;
}

export default function Checkbox({
	children,
	ref,
	widget,
	track,
	disabled = false,
	className,
	...props
}: CheckboxProps & LabelVariants & TrackVariants) {
	const [focusVisible, setFocusVisible] = useState(false);
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: <explanation>
		<label
			className={`${label({ widget, disabled })} ${className}`}
			data-checked={props.checked}
			data-focus-visible={focusVisible || undefined}
			onMouseOut={() => setFocusVisible(false)}
			onMouseOver={() => setFocusVisible(true)}
			onBlur={() => setFocusVisible(false)}
			onFocus={() => setFocusVisible(true)}
		>
			<VisuallyHidden>
				<AriaCheckbox
					{...props}
					ref={ref}
					role={widget}
					disabled={disabled}
					clickOnEnter
					onFocusVisible={() => setFocusVisible(true)}
					onBlur={() => setFocusVisible(false)}
					onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
						props.onChange?.(event);
					}}
				/>
			</VisuallyHidden>
			{widget === "switch" ? (
				<ToggleSwitch
					checked={props.checked ?? false}
					focused={focusVisible}
					track={track}
				/>
			) : (
				<CustomCheckbox
					checked={props.checked ?? false}
					focused={focusVisible}
					disabled={disabled}
				/>
			)}
			<span className={childrenStyles({ disabled: disabled })}>{children}</span>
		</label>
	);
}

function CustomCheckbox(props: {
	checked: boolean;
	focused: boolean;
	disabled: boolean;
}) {
	// const state = props.disabled
	// 	? "disabled"
	// 	: props.checked
	// 		? "checked"
	// 		: props.focused
	// 			? "hover"
	// 			: "unchecked";

	return <div className={`custom-checkbox ${input(props)}`} />;
}
